module.exports = __webpack_public_path__ + "static/media/823NorthAvenueNW_2018-07-09_150.3598e7b5.jpg";